<template>
  <div class="address-picker" v-if="areas">
    <div class="form-group row">
      <label for="original-address" class="col-2 col-form-label">地址</label>
      <div class="col-10">
        <input class="form-control" type="text" :value="value" id="original-address" readonly>
      </div>
    </div>
    <div class="form-group row">
      <label for="consignee-address" class="col-2 col-form-label">详细地址</label>
      <div class="col-10 form-row">
        <div class="col">
          <select title="省" v-model="province" class="form-control" :class="{active: province}"
              @change="city = ''; district = ''">
            <option value="">请选择省</option>
            <option :value="province" v-for="(cities, province) in areas">{{province}}</option>
          </select>
        </div>
        <div class="col">
          <select title="市" v-model="city" class="form-control" @change="district = ''"
                  :class="{active: city}" :disabled="!province">
            <option value="">市</option>
            <option :value="city" v-for="city in cities">{{city}}</option>
          </select>
        </div>
        <div class="col">
          <select title="区/县" v-model="district" class="form-control" :class="{active: district}" :disabled="!city">
            <option value="">区/县</option>
            <option :value="district" v-for="district in districts">{{district}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="consignee-address" class="col-2 col-form-label"></label>
      <div class="col-10 form-row">
        <textarea name="street" placeholder="请填写详细地址" class="form-control" v-model="street"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
  let http = require('axios')

  export default {
    name: 'address-picker',
    data () {
      return {
        areas: null,
        province: '',
        city: '',
        district: '',
        street: ''
      }
    },
    props: ['value'],
    created () {
      const address = this.value
      if (address && address.split('|').length === 4) {
        const paris = address.split('|')
        this.province = paris[0]
        this.city = paris[1]
        this.district = paris[2]
        this.street = paris[3]
      }
      this.fetchAreas().then(data => {
        this.areas = data
      })
    },
    watch: {
      address (val) {
        this.$emit('input', val)
      }
    },
    computed: {
      address () {
        const address = [this.province, this.city, this.district, this.street]
        // 省市区的表达式
        if (address.every(item => !!item)) {
          return address.map(item => item.trim().replace('|', ' ')).join('|')
        } 
        // 国际地址的表达
        else if (address.slice(0, 3).every(item => !item) && address[3]) {
          return address.map(item => item.trim().replace('|', ' ')).join('|')
        }
        return ''
      },
      cities () {
        if (this.province && this.areas) {
          if (this.areas.hasOwnProperty(this.province)) {
            return Object.keys(this.areas[this.province])
          }
        }
        return []
      },
      districts () {
        if (this.city && this.province) {
          if (this.areas[this.province] && this.areas[this.province].hasOwnProperty(this.city)) {
            return this.areas[this.province][this.city]
          }
        }
        return []
      }
    },
    methods: {
      fetchAreas () {
        let url = '/api/proxy?use_proxy=true&url=' + encodeURIComponent('https://ark.xinshu.me/buckets/weixinshu:areas')
        return http.get(url).then(response => {
          const data = response.data.data
          return this.parseAreas(data)
        })
      },
      parseAreas (areas) {
        const result = {}
        for (const area of areas) {
          for (const key of Object.keys(area)) {
            result[key] = area[key]
            if (typeof area[key][0] !== 'string') {
              result[key] = this.parseAreas(result[key])
            }
          }
        }
        return result
      }
    }
  }
</script>

<style scoped type="text/scss" lang="scss">
  .address-picker {
    .select {
      margin-bottom: 1em;
      font-size: 12px;
    }
  }
</style>